namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_app, {
		
		background: {
			size: [ 'cover' ],
			position: 'center',
		},
		
		'--mol_theme_hue': '10deg',
		
		Menu: {
			'@media': {
				'print': {
					display: 'none',
				}
			},
		},
		
		Summary: {
			Head: {
				'@media': {
					'print': {
						display: 'none',
					}
				},
			}
		},
		
	} )
	
}
